import { FC } from 'react';

import { SectionError } from '@components/ui/error';
import { SectionLoader } from '@components/ui/loader';

import { Route } from '@/constants';
import { CreateUser } from '@/modules/users/create-user';
import { UpdateUserFormSchema } from '@/modules/users/create-user/create-user.schema';
import { useEditUser } from '@/modules/users/edit-user/edit-user.hook';

export const EditUser: FC = () => {
    const {
        handleSubmit,
        data,
        isLoading,
        isFetching,
        isError,
        error,
        isUpdating,
    } = useEditUser();

    if (isLoading || isFetching) {
        return <SectionLoader />;
    }

    if (isError) {
        return <SectionError error={error} fallbackPath={Route.USERS} />;
    }

    return (
        <CreateUser
            title={'Update User'}
            submitButtonText={'Update User'}
            breadcrumbLabel={'Edit User'}
            initialValues={{
                name: data?.data?.name || '',
                email: data?.data?.email || '',
                role_id: data?.data?.role_id || '',
                phone_number: data?.data?.phone_number || '',
                status: data?.data?.status || 'active',
                password: '',
            }}
            schema={UpdateUserFormSchema}
            handleSubmit={handleSubmit}
            isSubmitting={isUpdating}
        />
    );
};

EditUser.displayName = 'EditUser';
